<div class="mb-1.5 flex flex-col gap-1">
  <label [for]="id()" class="mb-1 text-sm font-semibold text-gray-800">
    {{ label() }}
    @if (optional()) {
      <span
        class="ml-1 rounded-sm bg-gray-100 px-1.5 py-0.5 text-xs font-light whitespace-nowrap text-gray-700">
        optional
      </span>
    }
  </label>

  <div class="relative">
    @if (useFormControl()) {
      <input
        [id]="id()"
        [type]="type()"
        [formControl]="control()!"
        [placeholder]="placeholder()"
        [readonly]="readonly()"
        (blur)="blurred.emit()"
        class="w-full rounded-lg border px-3 py-2 text-sm outline-none"
        [ngClass]="[inputClass(), inputPaddingClass()]" />
    } @else {
      <input
        #inputElement
        [id]="id()"
        [type]="type()"
        [value]="inputValue()"
        [placeholder]="placeholder()"
        [readonly]="readonly()"
        (change)="onValueChanged(inputElement)"
        (blur)="blurred.emit()"
        class="w-full rounded-lg border px-3 py-2 text-sm outline-none"
        [ngClass]="[inputClass(), inputPaddingClass()]" />
    }

    @if (showRevertButton()) {
      <button
        type="button"
        aria-label="Zurücksetzen"
        (click)="onRevertClicked($event)"
        class="group absolute top-1/2 right-1.5 flex size-7 -translate-y-1/2 items-center justify-center rounded-sm text-gray-700 transition-colors hover:bg-gray-100 hover:text-gray-900 focus:ring-1 focus:ring-gray-300 focus:outline-none">
        <svg aria-hidden="true" class="size-4">
          <use href="@dashboard-web-order/icons/undo-2.svg#undo-2"></use>
        </svg>
        <span
          class="pointer-events-none absolute right-0 bottom-full z-10 mb-1 hidden rounded-sm bg-gray-900 px-2 py-1 text-xs whitespace-nowrap text-white shadow-sm group-hover:block">
          Zurücksetzen
        </span>
      </button>
    }
  </div>

  <span class="min-h-4 text-xs" [ngClass]="statusClass()">
    @if (showWarningState() && warningOriginalValue()) {
      <span>{{ statusText() }}</span>
      <span class="ml-2 text-gray-500">Original: {{ warningOriginalValue() }}</span>
    } @else {
      {{ statusText() }}
    }
  </span>
</div>
